const state = {
    allocation: [],
    id: [],
    payroll: [],
    employee_payroll: [],
    u_id: [],
    loading: false
};

export default state;